import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { API, ReportInputTypes } from 'src/app/shared/models/common';
import { AuthService } from 'src/app/auth/services/auth.service';

export interface ScopeOption {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class TopFilterService {
  public topFilterForm: FormGroup;

  /* The dashboard's Area and Branch with their names, for screens that
     start from the same scope (the clients list). The form only holds ids,
     and a search-select needs the name to show a preset value. null = All. */
  private selectedArea: ScopeOption | null = null;
  private selectedBranch: ScopeOption | null = null;
  private scopeSet = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
  ) {
    this.topFilterForm = this.formBuilder.group({
      [ReportInputTypes.AREA]: [0, [Validators.required]],
      [ReportInputTypes.BRANCH]: [0, [Validators.required]],
      [ReportInputTypes.LOAN_OFFICER]: [0, [Validators.required]],
      [ReportInputTypes.START_DATE]: [new Date(), [Validators.required]],
      [ReportInputTypes.END_DATE]: [new Date(), [Validators.required]],
      [ReportInputTypes.CURRENCY]: [''],
    });
  }

  public setScope(area: ScopeOption | null, branch: ScopeOption | null) {
    this.selectedArea = area?.id ? area : null;
    this.selectedBranch = branch?.id ? branch : null;
    this.scopeSet = true;
  }

  /* The scope the dashboard shows. Before the dashboard has been opened this
     session that is its own default, the user's area and branch. */
  public currentScope(): { area: ScopeOption | null; branch: ScopeOption | null } {
    if (this.scopeSet) {
      return { area: this.selectedArea, branch: this.selectedBranch };
    }
    const user = this.authService.getuser;
    return {
      area: user?.area?.id ? { id: user.area.id, name: user.area.name } : null,
      branch: user?.branch?.id
        ? { id: user.branch.id, name: user.branch.name }
        : null,
    };
  }
}
